'use es6';

import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIFieldset from 'UIComponents/form/UIFieldset';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UILink from 'UIComponents/link/UILink';
import { i18nKey as baseI18nKey, LinkRelTypes, LinkRelDefault } from '../../constants/link';
import { CustomizeLinkAttributesUrl, sharedI18nKey } from '../../constants/shared';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => baseI18nKey(`advanced.${suffix}`);
const renderRelRadioButton = (relType, curRelAttr = [], onChange, disabled) => {
  let checked = curRelAttr.includes(relType);
  if (relType === LinkRelTypes.REGULAR) {
    checked = curRelAttr.length === 0 || curRelAttr.length === 1 && curRelAttr[0] === LinkRelDefault;
  }
  return /*#__PURE__*/_jsx(UICheckbox, {
    disabled: disabled,
    checked: !disabled && checked,
    onChange: () => onChange(relType, !checked),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey(`rel.${relType}`)
    })
  }, `rel-type-${relType}`);
};
const propTypes = {
  className: PropTypes.string,
  tooltipClassName: PropTypes.string,
  relAttr: PropTypes.array.isRequired,
  onRelAttrChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
function LinkAdvancedPopoverControls(props) {
  const {
    className,
    tooltipClassName,
    relAttr,
    onRelAttrChange,
    disabled
  } = props;
  const handleRelAttrChange = (relType, checked) => {
    let updatedRelAttr;
    if (relType === LinkRelTypes.REGULAR) {
      updatedRelAttr = [];
    } else {
      updatedRelAttr = checked ? [...relAttr, relType] : relAttr.filter(attr => attr !== relType);
    }
    onRelAttrChange(updatedRelAttr);
  };
  let tooltip;
  if (disabled) {
    tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('disabledTooltip')
    });
  } else {
    tooltip = /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('help')
      }), ' ', /*#__PURE__*/_jsx(UILink, {
        href: CustomizeLinkAttributesUrl,
        external: true,
        onMouseDown: evt => evt.preventDefault(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: sharedI18nKey('learnMore')
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(UIFieldset, {
    className: className,
    _size: "small",
    children: /*#__PURE__*/_jsx(UIFormControl, {
      label: I18n.text(i18nKey('label')),
      tooltip: tooltip,
      tooltipPlacement: "top right",
      tooltipProps: {
        innerClassName: tooltipClassName
      },
      children: /*#__PURE__*/_jsx(UIToggleGroup, {
        name: "rel-type",
        children: Object.values(LinkRelTypes).map(relType => renderRelRadioButton(relType, relAttr, handleRelAttrChange, disabled))
      })
    })
  });
}
LinkAdvancedPopoverControls.propTypes = propTypes;
LinkAdvancedPopoverControls.displayName = 'LinkAdvancedPopoverControls';
export default LinkAdvancedPopoverControls;